import { cn } from "@/lib/utils";

export const ProgressBar = ({ value = 0, className, showLabel = false, ...props }) => {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div
        className="h-2.5 flex-1 overflow-hidden rounded-full bg-[#EEF2FB]"
        data-testid={props["data-testid"] || "progress-bar"}
      >
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${clamped}%`, backgroundColor: "var(--accent-primary)" }}
        />
      </div>
      {showLabel && (
        <span className="w-9 text-right text-xs font-bold text-[#14245F]">{clamped}%</span>
      )}
    </div>
  );
};
